export default __webpack_public_path__ + "static/media/instagram.ce7d948e.svg";